/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelImportSalaryTablePost$Plain$Params {
  year?: string;
  tranche?: number;
      body?: {
'uploadedFile'?: Blob;
}
}

export function apiExcelExcelImportSalaryTablePost$Plain(http: HttpClient, rootUrl: string, params?: ApiExcelExcelImportSalaryTablePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelImportSalaryTablePost$Plain.PATH, 'post');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('tranche', params.tranche, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelImportSalaryTablePost$Plain.PATH = '/api/Excel/Excel_ImportSalaryTable';
